module.exports = new __parcel__URL__("blackstar.af67465d.jpg").toString();